///CategorieModel.jsx
class CategorieModel {
    constructor(data = {}) {
        this.id = data.id || null;
        this.nomCat = data.nomCat || null;
    }

    // Sérialiser pour envoyer vers API ou autre
    toJSON() {
        return {
            id: this.id,
            nomCat: this.nomCat,
        };
    }

    // Mettre à jour les données
    update(data = {}) {
        if (data.id !== undefined) this.id = data.id;
        if (data.nomCat !== undefined) this.nomCat = data.nomCat;
    }
}

export default CategorieModel;
